const CampaignTypes = {
    GET_CAMPAIGNS: "GET_CAMPAIGNS",
    GET_CAMPAIGNS_SUCCESS: "GET_CAMPAIGNS_SUCCESS"
};

export { CampaignTypes };